// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetAcademicYearsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AcademicYearDTO from '../models/AcademicYearDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    numberOfAcademicYears: number | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            numberOfAcademicYears: null,
        },
        initValues);
    },
    numberOfAcademicYears: 'numberOfAcademicYears',
}

interface Result extends ResultDTO {
    academicYears: AcademicYearDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            academicYears: [],
        },
        initValues);
    },
    academicYears: 'academicYears',
}

export { Request, Result };